const Title = () => (
    <section id="title">
        <div className="container-fluid pt-4 pb-4 text-center">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-11">
                    <h3 className="mb-5"><b>Good news!</b> You qualify for a one‑time <b>SPECIAL UPGRADE.</b></h3>
                    <h5 className="fw-light">This upgrade is shown only once and is reserved exclusively for NEW customers.</h5>
                </div>
            </div>
        </div>
    </section>
);

export default Title;